export default __webpack_public_path__ + "static/media/WhiteOpciones.d14d17a7.svg";